"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloudCallable = exports.artist = void 0;
const members_1 = require("./artist/members");
const functions_1 = require("firebase/functions");
exports.artist = { members: members_1.members };
const cloudCallable = (name) => (0, functions_1.httpsCallable)(name === "signup-account"
    ? (0, functions_1.getFunctions)(undefined, "us-west2")
    : (0, functions_1.getFunctions)(), name);
exports.cloudCallable = cloudCallable;
//# sourceMappingURL=index.js.map